// extracted by mini-css-extract-plugin
export default {"root":"ApplicationsHeader_root__uKP1n","aside":"ApplicationsHeader_aside__BzLBW","countWrapper":"ApplicationsHeader_countWrapper__CI8Pl"};